export const SET_DRAWDOWN_DATA = 'page/SET_DRAWDOWN_DATA';
export const LEAVE_DRAW_DOWN = 'page/DRAW_DOWN [leaving]';

export const DRAW_DOWN_PENDING = 'page/DRAW_DOWN [loading]';

export const NEXT_DRAW_DOWN_STEP_LOADING = 'page/NEXT_DRAW_DOWN_STEP_LOADING';
export const PREVIOUS_DRAW_DOWN_STEP_LOADING =
    'page/PREVIOUS_DRAW_DOWN_STEP_LOADING';

export const DRAW_DOWN_COMPLETE_APPLICATION_DATA =
    'page/DRAW_DOWN_COMPLETE_APPLICATION [done]';
export const DRAW_DOWN_CONFIRM_DATA = 'page/DRAW_DOWN_CONFIRM [done]';

export const GET_REPAYMENT_SCHEDULE = 'page/GET_REPAYMENT_SCHEDULE [done]';

export const DRAW_DOWN_COMPLETE_APPLICATION_FUNDING_REQUIREMENTS =
    'page/DRAW_DOWN_COMPLETE_APPLICATION_FUNDING_REQUIREMENTS';

export const CONFIRM_DRAW_DOWN = 'page/CONFIRM_DRAW_DOWN';

export const COMPLETE_APPLICATION_ACTION = 'page/COMPLETE_APPLICATION_ACTION';

export const SELECT_DRAW_DOWN_FUNDING_METHOD =
    'page/SELECT_DRAW_DOWN_FUNDING_METHOD';
export const SELECT_DRAW_DOWN_REPAYMENT_METHOD =
    'page/SELECT_DRAW_DOWN_REPAYMENT_METHOD';

export const MAJOR_SHAREHOLDER_ADDED = 'MAJOR_SHAREHOLDER_ADDED';
